export default __webpack_public_path__ + "static/media/twitter-color.5d2c2206.svg";